module.exports = __webpack_public_path__ + "static/media/coupon.9559f2c4.svg";